import { ISortVariant } from '../../repositories/dailyrent/entities/sort_variant/SortVariant';
import { IApplicationState } from '../../types/redux';

export function selectSortVariants(state: IApplicationState): ISortVariant[] {
  return state.listingOffers.sortVariants;
}
